import { Directive, effect, ElementRef, input } from '@angular/core';

@Directive({
  selector: 'fa-icon[color]'
})
export class FaIconColorDirective {
  color = input.required<string>();

  private previousClass: string | null = null;

  // eslint-disable-next-line @typescript-eslint/member-ordering
  constructor(private el: ElementRef) {
    effect(() => {
      if (this.previousClass) {
        this.el.nativeElement.classList.remove(this.previousClass);
      }
      const cls = `eiq-icon-${this.color()}`;
      this.el.nativeElement.classList.add(cls);
      this.previousClass = cls;
    });
  }
}
